module.exports = __webpack_public_path__ + "media/images/icons/icon_close_primary-48921fc6928be9223d1d6896f3f593c4.svg";